import {
  CountryCell,
  CurrencyDropDownCell,
  DateCell,
  LinkCell,
  ProgressCell,
  TagCell,
} from '../modules/VehiclesGrid/GridCellRenderers';
import { IColumnMetaData } from '../types';
import { ISearchCustomer, ISearchInvCustomerWithoutOrder, Inventory } from '../types/inventory';
import { MetaData } from '../types/metaData';
import { Res } from '../types/service';
import { ENDPOINTS, META_DATA_MODULES, META_DATA_SUB_MODULES } from '../utils/constants';
import request from './HttpService';

interface Props {
  method: 'GET' | 'POST' | 'DELETE' | 'PUT' | 'PATCH';
  data?: any;
  params?: object;
  url?: string;
}

export const getMetaData = async (module: string, subModule: string): Promise<MetaData> => {
  const response = await request.get(ENDPOINTS.metaData, {
    params: {
      module,
      subModule,
    },
  });
  return response.data.data[0];
};

export const CellTypes = {
  Link: LinkCell,
  Tag: TagCell,
  Date: DateCell,
  CurrencyDropDown: CurrencyDropDownCell,
  Country: CountryCell,
  ProgressBar: ProgressCell,
  Plain: undefined,
};

export const getColDefs = async () => {
  const response = await getMetaData(META_DATA_MODULES.vehicles, META_DATA_SUB_MODULES.vehiclesGrid);
  const colMetaDataList: IColumnMetaData[] = response?.columnDetails;

  return colMetaDataList.map((colMetaData) => {
    const colDef: any = { field: colMetaData.property, headerName: colMetaData.propertyName };
    colDef.width = colMetaData.width;
    colDef.filter = colMetaData.filterType;
    colDef.type = colMetaData.type;
    return colDef;
  });
};

export const getInventoryDetails = async (
  perPage: number,
  page: number,
  sortStatus?: boolean,
  sort?: any,
  filterText?: any,
  grouping?: any,
  groupKeys?: any,
  filterKeys?: any,
  filterOpKeys?: any
) => {
  try {
    if (filterKeys?.length > 0) {
      filterKeys = filterKeys.join('|');
      if (filterOpKeys?.length > 0) {
        filterOpKeys = filterOpKeys.join('|');
      }
    }

    const response = await request.post<Res<Inventory[]>>(
      ENDPOINTS.inventoryDetails(perPage, page, sortStatus, sort, grouping, groupKeys),
      {
        searchText: filterText?.toString(),
        filter: filterKeys
          .toString()
          .replace(/inventoryVehicle./gi, 'inventoryVehicle_')
          .replace(/customerVehicle./gi, 'customerVehicle_'),
        filterOp: filterOpKeys.toString(),
      }
    );
    return response.data;
  } catch (err) {
    console.log(err);
    return { data: [] };
  }
};

export const updateOfacDetails = async (orderId: string) => {
  const response = await request.get<Res<Inventory[]>>(ENDPOINTS.ofacDetails, {
    params: {
      orderId,
    },
  });
  return response.data.data;
};

export const searchCustomer = async (query: string, country: string, shippingCountry: string) => {
  const response = await request.get<Res<ISearchCustomer[]>>(ENDPOINTS.searchInventoryCustomer, {
    params: {
      query,
      country,
      shippingCountry,
    },
  });
  return response.data.data;
};

export const searchCustomerWithOutOrder = async (query: string) => {
  const response = await request.get<Res<ISearchInvCustomerWithoutOrder[]>>(ENDPOINTS.searchInvCustomerWithoutOrder, {
    params: {
      query,
    },
  });
  return response.data.data;
};

export const getInventoryFilterValues = async (fieldName: string) => {
  fieldName = fieldName.replace('.', '_');
  try {
    return (await request.post(ENDPOINTS.getInventoryFilterValues(fieldName))).data || [];
  } catch (err) {
    return { data: [] };
  }
};
